export default "__VITE_ASSET__DVyLyzu$__"